import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';

import {
    GetAllFinancialInformationForCategory,
    GetAllFinancialInformationForEmployee,
    GetAllFinancialInformationForProject,
} from '../../../financial/financial.actions';
import YukiDocument from '../../../models/yuki/YukiDocument';
import { InvoiceInformationModalComponent } from '../../../yuki/invoice-information-modal/invoice-information-modal.component';
import { FetchDocumentById } from '../../../yuki/yuki.actions';

@Component({
    selector: 'app-pill-invoice',
    templateUrl: './pill-invoice.component.html',
    styleUrls: ['./pill-invoice.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PillInvoiceComponent implements OnInit, OnDestroy {
    /**
     * @deprecated
     * Use invoiceId and title if available
     */
    @Input() yukiDocumentId: string;
    @Input() invoiceId: string;
    @Input() title: string;
    @Input() linkedObjectId?: string;
    @Input() refreshObjectId?: string;
    @Input() refreshObjectType?: 'EMPLOYEE' | 'PROJECT' | 'CATEGORY';
    @Input() refreshFinancialMonth?: number;
    @Input() refreshFinancialYear?: number;
    yukiDocument: YukiDocument;
    private subscriptions = new Subscription();

    constructor(private store: Store, private modalService: NgbModal) {}

    ngOnInit(): void {
        if (this.yukiDocumentId) {
            this.fetchData();
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    openInvoiceInformationModal() {
        const modalRef = this.modalService.open(InvoiceInformationModalComponent, {
            windowClass: 'modal-full-screen',
            animation: false,
        });
        if (this.yukiDocumentId) {
            modalRef.componentInstance.yukiDocumentId = this.yukiDocument.uuid;
        } else {
            modalRef.componentInstance.yukiDocumentId = this.invoiceId;
        }
        modalRef.componentInstance.linkedObjectId = this.linkedObjectId;

        if (this.refreshObjectId && this.refreshObjectType && this.refreshFinancialMonth && this.refreshFinancialYear) {
            modalRef.closed.subscribe(() => {
                if (this.refreshObjectType === 'EMPLOYEE') {
                    this.store.dispatch(new GetAllFinancialInformationForEmployee(this.refreshObjectId, this.refreshFinancialMonth, this.refreshFinancialYear));
                } else if (this.refreshObjectType === 'PROJECT') {
                    this.store.dispatch(new GetAllFinancialInformationForProject(this.refreshObjectId, this.refreshFinancialMonth, this.refreshFinancialYear));
                } else if (this.refreshObjectType === 'CATEGORY') {
                    this.store.dispatch(new GetAllFinancialInformationForCategory(this.refreshObjectId, this.refreshFinancialMonth, this.refreshFinancialYear));
                }
            });
        }
    }

    private fetchData() {
        this.subscriptions.add(
            this.store.dispatch(new FetchDocumentById(this.yukiDocumentId)).subscribe((state) => (this.yukiDocument = state.yuki.documentForInformationModal)),
        );
    }
}
